import React, { useEffect, useState, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUsuarioByUser_Id, getUsers, getPagosByUser_Id, updateUser, createEjercicio, putEjercicioByEjercicio_Id, getAsistenciaByUser_Id, getEjercicioByUser_Id, createPeso, getPesoByUser_Id, deletePesoBy_Id, deleteEjercicioBy_Id } from "../api";
import UserPagoVerForm from "../components/UserPagoVerForm";
import UserAsistenciaVerForm from "../components/UserAsistenciaVerForm";
import UserEjercicioVerForm from "../components/UserEjercicioVerForm";
import UserContrasena from "../components/UserContrasena";
import UserEjercicioForm from "./UserEjercicioForm";
import UserPesoVerForm from "../components/UserPesoVerForm";
import UserPesoForm from "./UserPesoForm";
import UserDetailsForm from "../components/UserDetailsForm";
import UsuarioVerHalconForm from "./UsuarioVerHalconForm";
import Banner from "../components/Banner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faBars } from "@fortawesome/free-solid-svg-icons";

const HalconPage = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = location.state || {};
  const [showEjercicioSubMenu, setShowEjercicioSubMenu] = useState(false);
  const [showPesoSubMenu, setShowPesoSubMenu] = useState(false);
  const [showUsuarioSubMenu, setShowUsuarioSubMenu] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [asistencias, setAsistencias] = useState([]);
  const [ejercicios, setEjercicios] = useState([]);
  const [pesos, setPesos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSection, setSelectedSection] = useState("Todos"); // Default section

  // Referencias para los menús
  const ejercicioMenuRef = useRef(null);
  const pesoMenuRef = useRef(null);
  const usuarioMenuRef = useRef(null);

  // Fetch user data
  const loadUsers = useCallback(async () => {
    try {
      setLoading(true);
      await new Promise(resolve => setTimeout(resolve, 500));
      const { data } = await getUsuarioByUser_Id(userData[0].id_usuario);

      setUsers(data);
    } catch (error) {
      console.error("Error loading users:", error);
    } finally {
      setLoading(false);
    }
  }, [userData]);

    // Fetch asistencias data
    const loadAsistencias = useCallback(async () => {
      try {
        setLoading(true);
        const { data } = await getAsistenciaByUser_Id(userData[0].id_usuario);
        setAsistencias(data);
      } catch (error) {
        console.error("Error loading asistencias:", error);
      } finally {
        setLoading(false);
      }
    }, [userData]);

  // Fetch ejercicios data (adjust as needed for Agregar/Ver)
  const loadEjercicios = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await getEjercicioByUser_Id(userData[0].id_usuario);
      setEjercicios(data);
    } catch (error) {
      console.error("Error loading ejercicios:", error);
    } finally {
      setLoading(false);
    }
  }, [userData]);

    // Fetch ejercicios data (adjust as needed for Agregar/Ver)
    const loadPesos = useCallback(async () => {
      try {
        setLoading(true);
        const { data } = await getPesoByUser_Id(userData[0].id_usuario);
        setPesos(data);
      } catch (error) {
        console.error("Error loading ejercicios:", error);
      } finally {
        setLoading(false);
      }
    }, [userData]);

  useEffect(() => {
    if (userData) {
      loadUsers();
      loadAsistencias();
      loadEjercicios();
      loadPesos();
    }
  }, [loadUsers, loadEjercicios, loadPesos, loadAsistencias, userData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ejercicioMenuRef.current && 
        !ejercicioMenuRef.current.contains(event.target) && 
        pesoMenuRef.current &&
        !pesoMenuRef.current.contains(event.target) &&
        usuarioMenuRef.current &&
        !usuarioMenuRef.current.contains(event.target)
      ) {
        setShowEjercicioSubMenu(false);
        setShowPesoSubMenu(false);
        setShowUsuarioSubMenu(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  if (loading) {
    return <div className="loader"></div>;
  }

  const handleLogoutRedirect = () => {
    navigate("/");
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    // Ocultar el menú automáticamente al hacer clic en cualquier opción
  const handleMenuOptionClick = (section) => {
      setIsMenuOpen(false); 
      setSelectedSection({ section }); // Asume que esta función está definida en tu contexto o componente padre
    }

  const toggleEjercicioSubMenu = () => {
    setShowEjercicioSubMenu((prevShowEjercicioSubMenu) => !prevShowEjercicioSubMenu);
  };

  const togglePesoSubMenu = () => {
    setShowPesoSubMenu((prevShowPesoSubMenu) => !prevShowPesoSubMenu);
  };

  const toggleUsuarioSubMenu = () => {
    setShowUsuarioSubMenu((prevShowUsuarioSubMenu) => !prevShowUsuarioSubMenu);
  };

  const renderSection = () => {
    let users2=""
    let nombre_completo=""
    switch (selectedSection.section) {
      case "Todos":
              return <UsuarioVerHalconForm user={users[0]}  getUsers={getUsers} setSelectedSection={setSelectedSection} />;
        case "Pagos":
        users2=userData[0].id_usuario
        nombre_completo=userData[0].nombre_completo
        return <UserPagoVerForm user={users2} getPagosByUser_Id={getPagosByUser_Id} nombre_completo={nombre_completo}/>;
      case "Asistencias":
        return <UserAsistenciaVerForm user={users[0]} asistencias={asistencias} getAsistenciaByUser_Id={getAsistenciaByUser_Id} />;  
      case "Ejercicio_Agregar":
        return (
          <UserEjercicioForm
            user={users[0]}
            ejercicios={ejercicios}
            createEjercicio={createEjercicio}
          />
        );
      case "Ejercicio_Ver":
        return (
          <UserEjercicioVerForm
            user={users[0]}
            ejercicios={ejercicios}
            getEjercicioByUser_Id={getEjercicioByUser_Id}
            deleteEjercicioBy_Id={deleteEjercicioBy_Id}
            putEjercicioByEjercicio_Id={putEjercicioByEjercicio_Id}
          />
        );
        case "Peso_Agregar":
          return (
            <UserPesoForm
              user={users[0]}
              pesos={pesos}
              createPeso={createPeso}
            />
          );
        case "Peso_Ver":
          return (
            <UserPesoVerForm
              user={users[0]}
              pesos={pesos}
              getPesoByUser_Id={getPesoByUser_Id}
              deletePesoBy_Id={deletePesoBy_Id}
            />
          );
          case "Usuario_datos":
            return (
              <UserDetailsForm
                user={users[0]}
                getUsers={getUsers}
                updateUser={updateUser}
                loadUsers={loadUsers}
              />
            );
          case "Usuario_contrasena":
            return (
              <UserContrasena
                user={users[0]}
                getUsers={getUsers}
                updateUser={updateUser}
                loadUsers={loadUsers}
              />
            );
      default:
        users2=userData[0].id_usuario
        nombre_completo=userData[0].nombre_completo
        return <UserPagoVerForm user={users2} getPagosByUser_Id={getPagosByUser_Id} nombre_completo={nombre_completo}/>;
    }
  };

  return (
    <div>
    {loading || !users ? (
      <div className="loader"></div>
    ) : (
    <div className="container">
      <Banner />
      <p>Bienvenido<br></br>
      {userData[0].nombre_completo}<br></br>
      Numero Halcon:
      <b><h1>{userData[0].id_usuario}</h1></b>
      Padrino: {userData[0].padrino} <br></br>
      Reto:<b> {userData[0].reto}</b><br></br>
      Estado de reto: {userData[0].estado_reto}<br></br><br></br></p>
      <center><i><b>{userData[0].frase_del_dia}</b></i></center>

      <div className="container3">
        <img src={`${apiBaseUrl}${userData[0].path_imagen}`} 
          width="75px" alt={`${apiBaseUrl}${userData[0].path_imagen}`} 
          className="cute-border">
        </img>
      </div>
      
      <div className="menu-bar">
        <button className="hamburger-button" onClick={toggleMenu}>
          <FontAwesomeIcon icon={faBars} />
        </button>
        <div className={`menu-content ${isMenuOpen ? 'show' : ''}`}>
          <button className="menu-button" onClick={() => handleMenuOptionClick("Todos")}>Todos</button>
          <button className="menu-button" onClick={() => handleMenuOptionClick("Pagos")}>Pagos</button>
          <button className="menu-button" onClick={() => handleMenuOptionClick("Asistencias")}>Asistencias</button>
          <button className="menu-button" onClick={toggleEjercicioSubMenu} ref={ejercicioMenuRef}>
            Ejercicio <FontAwesomeIcon icon={faChevronDown} />
          </button>
          <div className={`dropdown-ejercicio ${showEjercicioSubMenu ? "show" : ""}`}>
            <button className="dropdown-content" onClick={() => handleMenuOptionClick("Ejercicio_Agregar")}>Agregar</button>
            <button className="dropdown-content" onClick={() => handleMenuOptionClick("Ejercicio_Ver")}>Ver</button>
          </div>

          <button className="menu-button" onClick={togglePesoSubMenu} ref={pesoMenuRef}>
            Peso <FontAwesomeIcon icon={faChevronDown} />
          </button>
          <div className={`dropdown-peso ${showPesoSubMenu ? "show" : ""}`}>
            <button className="dropdown-content" onClick={() => handleMenuOptionClick("Peso_Agregar")}>Agregar</button>
            <button className="dropdown-content" onClick={() => handleMenuOptionClick("Peso_Ver")}>Ver</button>
          </div>

          <button className="menu-button" onClick={toggleUsuarioSubMenu} ref={usuarioMenuRef}>
            Usuario <FontAwesomeIcon icon={faChevronDown} />
          </button>
          <div className={`dropdown-usuario ${showUsuarioSubMenu ? "show" : ""}`}>
            <button className="dropdown-content" onClick={() => handleMenuOptionClick("Usuario_datos")}>Datos Usuario</button>
            <button className="dropdown-content" onClick={() => handleMenuOptionClick("Usuario_contrasena")}>Cambiar Contraseña</button>
          </div>
          <button className="menu-button" onClick={handleLogoutRedirect}>Salir</button>
        </div>
    </div>

      <div>{renderSection()}</div>
    </div>)}
    </div>
  );
};

export default HalconPage;
